import script from "./Table_SNV.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_SNV.vue?vue&type=script&setup=true&lang=js"

import "./Table_SNV.vue?vue&type=style&index=0&id=71831e67&lang=css"

const __exports__ = script;

export default __exports__